__turbopack_context__.v({
  "album": "album-module-scss-module__lKIsVW__album",
  "albumHover": "album-module-scss-module__lKIsVW__albumHover",
  "albumInfo": "album-module-scss-module__lKIsVW__albumInfo",
  "audioIcon": "album-module-scss-module__lKIsVW__audioIcon",
});
